// Various action type constants

// -----------------------------------------------------------------------------
// Login/profile requests

// User authentication requests
export const REQUEST_LOGIN = 'REQUEST_LOGIN'
export const RECEIVE_LOGIN = 'RECEIVE_LOGIN'
// Failure is handled by the popup widget thingy

export const REQUEST_PROFILE = 'REQUEST_PROFILE'
export const RECEIVE_PROFILE = 'RECEIVE_PROFILE'
export const RECEIVE_PROFILE_FAILURE = 'RECEIVE_PROFILE_FAILURE'

export const LOGOUT = 'LOGOUT'
export const STORE_POST_LOGIN_REDIRECT = 'STORE_POST_LOGIN_REDIRECT'

export const REQUEST_UPDATE_PROFILE = 'REQUEST_UPDATE_PROFILE'
export const RECEIVE_UPDATE_PROFILE = 'RECEIVE_UPDATE_PROFILE'
export const REQUEST_UPDATE_PROFILE_FAILURE = 'REQUEST_UPDATE_PROFILE_FAILURE'

export const SET_OVERRIDE_ACCESS_TOKEN = 'SET_OVERRIDE_ACCESS_TOKEN'

// -----------------------------------------------------------------------------
// Actions around local state

export const TOGGLE_REPORT_MODE = 'TOGGLE_REPORT_MODE'

// -----------------------------------------------------------------------------
// Actions around an topics (entities and video channels)

export const REQUEST_TOPICS = 'REQUEST_TOPICS'
export const RECEIVE_TOPICS = 'RECEIVE_TOPICS'
export const REQUEST_TOPICS_FAILURE = 'REQUEST_TOPICS_FAILURE'
export const INVALIDATE_TOPICS = 'INVALIDATE_TOPICS'

export const REQUEST_TOPICS_COUNT = 'REQUEST_TOPICS_COUNT'
export const RECEIVE_TOPICS_COUNT = 'RECEIVE_TOPICS_COUNT'
export const REQUEST_TOPICS_COUNT_FAILURE = 'REQUEST_TOPICS_COUNT_FAILURE'
export const INVALIDATE_TOPICS_COUNT = 'INVALIDATE_TOPICS_COUNT'

export const REQUEST_COMPARISONS = 'REQUEST_COMPARISONS'
export const RECEIVE_COMPARISONS = 'RECEIVE_COMPARISONS'
export const REQUEST_COMPARISONS_FAILURE = 'REQUEST_COMPARISONS_FAILURE'
export const INVALIDATE_COMPARISONS = 'INVALIDATE_COMPARISONS'

export const SET_TOPIC_PLAN_FILTERS = 'SET_TOPIC_PLAN_FILTERS'
export const SET_TOPIC_PLAN_RESET_FILTERS = 'SET_TOPIC_PLAN_RESET_FILTERS'
export const SET_COMPARE_TOPIC_PLAN_FILTERS = 'SET_COMPARE_TOPIC_PLAN_FILTERS'
export const SET_COMPARE_SELECTED_TOPIC_PLAN = 'SET_COMPARE_SELECTED_TOPIC_PLAN'
export const SET_TOPIC_PLAN_FILTER_ = 'SET_TOPIC_PLAN_FILTERS'

export const REQUEST_TOPIC_PLAN_METRICS = 'REQUEST_TOPIC_PLAN_METRICS'
export const RECEIVE_TOPIC_PLAN_METRICS = 'RECEIVE_TOPIC_PLAN_METRICS'
export const REQUEST_TOPIC_PLAN_METRICS_FAILURE = 'REQUEST_TOPIC_PLAN_METRICS_FAILURE'
export const INVALIDATE_TOPIC_PLAN_METRICS = 'INVALIDATE_TOPIC_PLAN_METRICS'

export const REQUEST_TOPIC_PLAN_SEGMENTS = 'REQUEST_TOPIC_PLAN_SEGMENTS'
export const RECEIVE_TOPIC_PLAN_SEGMENTS = 'RECEIVE_TOPIC_PLAN_SEGMENTS'
export const REQUEST_TOPIC_PLAN_SEGMENTS_FAILURE = 'REQUEST_TOPIC_PLAN_SEGMENTS_FAILURE'
export const INVALIDATE_TOPIC_PLAN_SEGMENTS = 'INVALIDATE_TOPIC_PLAN_SEGMENTS'

export const REQUEST_TOPIC_PLAN_DEMOGRAPHICS = 'REQUEST_TOPIC_PLAN_DEMOGRAPHICS'
export const RECEIVE_TOPIC_PLAN_DEMOGRAPHICS = 'RECEIVE_TOPIC_PLAN_DEMOGRAPHICS'
export const REQUEST_TOPIC_PLAN_DEMOGRAPHICS_FAILURE = 'REQUEST_TOPIC_PLAN_DEMOGRAPHICS_FAILURE'
export const INVALIDATE_TOPIC_PLAN_DEMOGRAPHICS = 'INVALIDATE_TOPIC_PLAN_DEMOGRAPHICS'

export const REQUEST_TOPIC_PLAN = 'REQUEST_TOPIC_PLAN'
export const RECEIVE_TOPIC_PLAN = 'RECEIVE_TOPIC_PLAN'
export const REQUEST_TOPIC_PLAN_FAILURE = 'REQUEST_TOPIC_PLAN_FAILURE'
export const INVALIDATE_TOPIC_PLAN = 'INVALIDATE_TOPIC_PLAN'

export const REQUEST_TOPIC_PLAN_ANTICIPATION = 'REQUEST_TOPIC_PLAN_ANTICIPATION'
export const RECEIVE_TOPIC_PLAN_ANTICIPATION = 'RECEIVE_TOPIC_PLAN_ANTICIPATION'
export const REQUEST_TOPIC_PLAN_ANTICIPATION_FAILURE = 'REQUEST_TOPIC_PLAN_ANTICIPATION_FAILURE'
export const INVALIDATE_TOPIC_PLAN_ANTICIPATION = 'INVALIDATE_TOPIC_PLAN_ANTICIPATION'

export const REQUEST_TOPIC_PLAN_EXPORT = 'REQUEST_TOPIC_PLAN_EXPORT'
export const RECEIVE_TOPIC_PLAN_EXPORT = 'RECEIVE_TOPIC_PLAN_EXPORT'
export const REQUEST_TOPIC_PLAN_EXPORT_FAILURE = 'REQUEST_TOPIC_PLAN_EXPORT_FAILURE'

export const REQUEST_TOPIC_DETAILS = 'REQUEST_TOPIC_DETAILS'
export const RECEIVE_TOPIC_DETAILS = 'RECEIVE_TOPIC_DETAILS'
export const REQUEST_TOPIC_DETAILS_FAILURE = 'REQUEST_TOPIC_DETAILS_FAILURE'
export const INVALIDATE_TOPIC_DETAILS = 'INVALIDATE_TOPIC_DETAILS'

export const REQUEST_TOPIC_MEDIA_PLAN = 'REQUEST_TOPIC_MEDIA_PLAN'
export const RECEIVE_TOPIC_MEDIA_PLAN = 'RECEIVE_TOPIC_MEDIA_PLAN'
export const REQUEST_TOPIC_MEDIA_PLAN_FAILURE = 'REQUEST_TOPIC_MEDIA_PLAN_FAILURE'
export const INVALIDATE_TOPIC_MEDIA_PLAN = 'INVALIDATE_TOPIC_MEDIA_PLAN'

// -----------------------------------------------------------------------------
// Actions around an homepage(s)

export const REQUEST_HOMEPAGE = 'REQUEST_HOMEPAGE'
export const RECEIVE_HOMEPAGE = 'RECEIVE_HOMEPAGE'
export const REQUEST_HOMEPAGE_FAILURE = 'REQUEST_HOMEPAGE_FAILURE'
export const INVALIDATE_HOMEPAGE = 'INVALIDATE_HOMEPAGE'

export const REQUEST_HOMEPAGE_TOPIC_DETAILS = 'REQUEST_HOMEPAGE_TOPIC_DETAILS'
export const RECEIVE_HOMEPAGE_TOPIC_DETAILS = 'RECEIVE_HOMEPAGE_TOPIC_DETAILS'
export const REQUEST_HOMEPAGE_TOPIC_DETAILS_FAILURE = 'REQUEST_HOMEPAGE_TOPIC_DETAILS_FAILURE'
export const INVALIDATE_HOMEPAGE_TOPIC_DETAILS = 'INVALIDATE_HOMEPAGE_TOPIC_DETAILS'

export const REQUEST_HOMEPAGE_TOPIC_PLAN = 'REQUEST_HOMEPAGE_TOPIC_PLAN'
export const RECEIVE_HOMEPAGE_TOPIC_PLAN = 'RECEIVE_HOMEPAGE_TOPIC_PLAN'
export const REQUEST_HOMEPAGE_TOPIC_PLAN_FAILURE = 'REQUEST_HOMEPAGE_TOPIC_PLAN_FAILURE'
export const INVALIDATE_HOMEPAGE_TOPIC_PLAN = 'INVALIDATE_HOMEPAGE_TOPIC_PLAN'

export const REQUEST_HOMEPAGE_ENGAGEMENT_NETWORK = 'REQUEST_HOMEPAGE_ENGAGEMENT_NETWORK'
export const RECEIVE_HOMEPAGE_ENGAGEMENT_NETWORK = 'RECEIVE_HOMEPAGE_ENGAGEMENT_NETWORK'
export const REQUEST_HOMEPAGE_ENGAGEMENT_NETWORK_FAILURE = 'REQUEST_HOMEPAGE_ENGAGEMENT_NETWORK_FAILURE'
export const INVALIDATE_HOMEPAGE_ENGAGEMENT_NETWORK = 'INVALIDATE_HOMEPAGE_ENGAGEMENT_NETWORK'

export const REQUEST_HOMEPAGE_DEMOGRAPHICS = 'REQUEST_HOMEPAGE_DEMOGRAPHICS'
export const RECEIVE_HOMEPAGE_DEMOGRAPHICS = 'RECEIVE_HOMEPAGE_DEMOGRAPHICS'
export const REQUEST_HOMEPAGE_DEMOGRAPHICS_FAILURE = 'REQUEST_HOMEPAGE_DEMOGRAPHICS_FAILURE'
export const INVALIDATE_HOMEPAGE_DEMOGRAPHICS = 'INVALIDATE_HOMEPAGE_DEMOGRAPHICS'

export const REQUEST_HOMEPAGE_WHATS_NEW = 'REQUEST_HOMEPAGE_WHATS_NEW'
export const RECEIVE_HOMEPAGE_WHATS_NEW = 'RECEIVE_HOMEPAGE_WHATS_NEW'
export const REQUEST_HOMEPAGE_WHATS_NEW_FAILURE = 'REQUEST_HOMEPAGE_WHATS_NEW_FAILURE'
export const INVALIDATE_HOMEPAGE_WHATS_NEW = 'INVALIDATE_HOMEPAGE_WHATS_NEW'

export const REQUEST_HOMEPAGE_TOP_SHOWS = 'REQUEST_HOMEPAGE_TOP_SHOWS'
export const RECEIVE_HOMEPAGE_TOP_SHOWS = 'RECEIVE_HOMEPAGE_TOP_SHOWS'
export const REQUEST_HOMEPAGE_TOP_SHOWS_FAILURE = 'REQUEST_HOMEPAGE_TOP_SHOWS_FAILURE'
export const INVALIDATE_HOMEPAGE_TOP_SHOWS = 'INVALIDATE_HOMEPAGE_TOP_SHOWS'

export const REQUEST_HOMEPAGE_TRENDING_VIDEOS = 'REQUEST_HOMEPAGE_TRENDING_VIDEOS'
export const RECEIVE_HOMEPAGE_TRENDING_VIDEOS = 'RECEIVE_HOMEPAGE_TRENDING_VIDEOS'
export const REQUEST_HOMEPAGE_TRENDING_VIDEOS_FAILURE = 'REQUEST_HOMEPAGE_TRENDING_VIDEOS_FAILURE'
export const INVALIDATE_HOMEPAGE_TRENDING_VIDEOS = 'INVALIDATE_HOMEPAGE_TRENDING_VIDEOS'

export const REQUEST_HOMEPAGE_ANTICIPATED_SHOWS = 'REQUEST_HOMEPAGE_ANTICIPATED_SHOWS'
export const RECEIVE_HOMEPAGE_ANTICIPATED_SHOWS = 'RECEIVE_HOMEPAGE_ANTICIPATED_SHOWS'
export const REQUEST_HOMEPAGE_ANTICIPATED_SHOWS_FAILURE = 'REQUEST_HOMEPAGE_ANTICIPATED_SHOWS_FAILURE'
export const INVALIDATE_HOMEPAGE_ANTICIPATED_SHOWS = 'INVALIDATE_HOMEPAGE_ANTICIPATED_SHOWS'

// -----------------------------------------------------------------------------
// Actions around an tracker(s)

export const REQUEST_TRACKER = 'REQUEST_TRACKER'
export const RECEIVE_TRACKER = 'RECEIVE_TRACKER'
export const REQUEST_TRACKER_FAILURE = 'REQUEST_TRACKER_FAILURE'
export const INVALIDATE_TRACKER = 'INVALIDATE_TRACKER'

export const REQUEST_TRACKER_PLAN = 'REQUEST_TRACKER_PLAN'
export const RECEIVE_TRACKER_PLAN = 'RECEIVE_TRACKER_PLAN'
export const REQUEST_TRACKER_PLAN_FAILURE = 'REQUEST_TRACKER_PLAN_FAILURE'

export const REQUEST_TRACKER_TIMELINE_VIEW = 'REQUEST_TRACKER_TIMELINE_VIEW'
export const RECEIVE_TRACKER_TIMELINE_VIEW = 'RECEIVE_TRACKER_TIMELINE_VIEW'
export const REQUEST_TRACKER_TIMELINE_VIEW_FAILURE = 'REQUEST_TRACKER_TIMELINE_VIEW_FAILURE'

export const REQUEST_AVERAGE_BENCH_MARK_TRACKER_PLAN = 'REQUEST_AVERAGE_BENCH_MARK_TRACKER_PLAN'
export const RECEIVE_AVERAGE_BENCH_MARK_TRACKER_PLAN = 'RECEIVE_AVERAGE_BENCH_MARK_TRACKER_PLAN'
export const REQUEST_AVERAGE_BENCH_MARK_TRACKER_PLAN_FAILURE = 'REQUEST_AVERAGE_BENCH_MARK_TRACKER_PLAN_FAILURE'

export const REQUEST_SINGLE_TRACKER_TIMELINE_VIEW = 'REQUEST_SINGLE_TRACKER_TIMELINE_VIEW'
export const RECEIVE_SINGLE_TRACKER_TIMELINE_VIEW = 'RECEIVE_SINGLE_TRACKER_TIMELINE_VIEW'
export const REQUEST_SINGLE_TRACKER_TIMELINE_VIEW_FAILURE = 'REQUEST_SINGLE_TRACKER_TIMELINE_VIEW_FAILURE'

export const REQUEST_SINGLE_TRACKER_PLAN = 'REQUEST_SINGLE_TRACKER_PLAN'
export const RECEIVE_SINGLE_TRACKER_PLAN = 'RECEIVE_SINGLE_TRACKER_PLAN'
export const REQUEST_SINGLE_TRACKER_PLAN_FAILURE = 'REQUEST_SINGLE_TRACKER_PLAN_FAILURE'

export const REQUEST_AVERAGE_BENCH_MARK_TRACKER_TIMELINE_VIEW = 'REQUEST_AVERAGE_BENCH_MARK_TRACKER_TIMELINE_VIEW'
export const RECEIVE_AVERAGE_BENCH_MARK_TRACKER_TIMELINE_VIEW = 'RECEIVE_AVERAGE_BENCH_MARK_TRACKER_TIMELINE_VIEW'
export const REQUEST_AVERAGE_BENCH_MARK_TRACKER_TIMELINE_VIEW_FAILURE = 'REQUEST_AVERAGE_BENCH_MARK_TRACKER_TIMELINE_VIEW_FAILURE'

export const REQUEST_TRACKER_PRIMARY_ENTITY_DETAILS = 'REQUEST_TRACKER_PRIMARY_ENTITY_DETAILS'
export const RECEIVE_TRACKER_PRIMARY_ENTITY_DETAILS = 'RECEIVE_TRACKER_PRIMARY_ENTITY_DETAILS'
export const REQUEST_TRACKER_PRIMARY_ENTITY_FAILURE = 'REQUEST_TRACKER_PRIMARY_ENTITY_FAILURE'
export const INVALIDATE_TRACKER_PRIMARY_ENTITY = 'INVALIDATE_TRACKER_PRIMARY_ENTITY'

export const REQUEST_TRACKER_TEASERS_TRAILERS = 'REQUEST_TRACKER_TEASERS_TRAILERS'
export const RECEIVE_TRACKER_TEASERS_TRAILERS = 'RECEIVE_TRACKER_TEASERS_TRAILERS'
export const REQUEST_TRACKER_TEASERS_TRAILERS_FAILURE = 'REQUEST_TRACKER_TEASERS_TRAILERS_FAILURE'
export const INVALIDATE_TRACKER_TEASERS_TRAILERS = 'INVALIDATE_TRACKER_TEASERS_TRAILERS'

export const REQUEST_TRACKER_WHATS_NEW = 'REQUEST_TRACKER_WHATS_NEW'
export const RECEIVE_TRACKER_WHATS_NEW = 'RECEIVE_TRACKER_WHATS_NEW'
export const REQUEST_TRACKER_WHATS_NEW_FAILURE = 'REQUEST_TRACKER_WHATS_NEW_FAILURE'
export const INVALIDATE_TRACKER_WHATS_NEW = 'INVALIDATE_TRACKER_WHATS_NEW'

export const REQUEST_TRACKER_WORD_CLOUD = 'REQUEST_TRACKER_WORD_CLOUD'
export const RECEIVE_TRACKER_WORD_CLOUD = 'RECEIVE_TRACKER_WORD_CLOUD'
export const REQUEST_TRACKER_WORD_CLOUD_FAILURE = 'REQUEST_TRACKER_WORD_CLOUD_FAILURE'
export const INVALIDATE_TRACKER_WORD_CLOUD = 'INVALIDATE_TRACKER_WORD_CLOUD'

export const TRACKER_SELECTED_ENTITY = 'TRACKER_SELECTED_ENTITY'

export const SINGLE_TRACKER_SELECTED_ENTITY = 'SINGLE_TRACKER_SELECTED_ENTITY'

// -----------------------------------------------------------------------------
// Actions around an umap

export const REQUEST_UMAP_TOPIC_PLAN = 'REQUEST_UMAP_TOPIC_PLAN'
export const RECEIVE_UMAP_TOPIC_PLAN = 'RECEIVE_UMAP_TOPIC_PLAN'
export const REQUEST_UMAP_TOPIC_PLAN_FAILURE = 'REQUEST_UMAP_TOPIC_PLAN_FAILURE'
export const INVALIDATE_UMAP_TOPIC_PLAN = 'INVALIDATE_UMAP_TOPIC_PLAN'

export const SET_UMAP_SELECTED_TOPIC = 'SET_UMAP_SELECTED_TOPIC'

export const REQUEST_DISCOVER_GENRE_DEMO = 'REQUEST_DISCOVER_GENRE_DEMO'
export const RECEIVE_DISCOVER_GENRE_DEMO = 'RECEIVE_DISCOVER_GENRE_DEMO'
export const REQUEST_DISCOVER_GENRE_DEMO_FAILURE = 'REQUEST_DISCOVER_GENRE_DEMO_FAILURE'
export const INVALIDATE_DISCOVER_GENRE_DEMO = 'INVALIDATE_DISCOVER_GENRE_DEMO'

// -----------------------------------------------------------------------------
// Actions around an rediscover

export const REQUEST_REDISCOVER_ENTITY_IMAGE = 'REQUEST_REDISCOVER_ENTITY_IMAGE'
export const RECEIVE_REDISCOVER_ENTITY_IMAGE = 'RECEIVE_REDISCOVER_ENTITY_IMAGE'
export const REQUEST_REDISCOVER_ENTITY_IMAGE_FAILURE = 'REQUEST_REDISCOVER_ENTITY_IMAGE_FAILURE'
export const INVALIDATE_REDISCOVER_ENTITY_IMAGE = 'INVALIDATE_REDISCOVER_ENTITY_IMAGE'

export const REDISCOVER_SELECTED_GENRE = 'REDISCOVER_SELECTED_GENRE'

export const REDISCOVER_SELECTED_GENRE_NETWORK = 'REDISCOVER_SELECTED_GENRE_NETWORK'

export const REQUEST_REDISCOVER_GENRE_DEMO = 'REQUEST_REDISCOVER_GENRE_DEMO'
export const RECEIVE_REDISCOVER_GENRE_DEMO = 'RECEIVE_REDISCOVER_GENRE_DEMO'
export const REQUEST_REDISCOVER_GENRE_DEMO_FAILURE = 'REQUEST_REDISCOVER_GENRE_DEMO_FAILURE'
export const INVALIDATE_REDISCOVER_GENRE_DEMO = 'INVALIDATE_REDISCOVER_GENRE_DEMO'

export const REQUEST_DISCOVER_GENRE_DEMO_SUMMARY = 'REQUEST_DISCOVER_GENRE_DEMO_SUMMARY'
export const RECEIVE_DISCOVER_GENRE_DEMO_SUMMARY = 'RECEIVE_DISCOVER_GENRE_DEMO_SUMMARY'
export const REQUEST_DISCOVER_GENRE_DEMO_SUMMARY_FAILURE = 'REQUEST_DISCOVER_GENRE_DEMO_SUMMARY_FAILURE'
export const INVALIDATE_DISCOVER_GENRE_DEMO_SUMMARY = 'INVALIDATE_DISCOVER_GENRE_DEMO_SUMMARY'

export const REQUEST_REDISCOVER_NETWORK_DETAILS = 'REQUEST_REDISCOVER_NETWORK_DETAILS'
export const RECEIVE_REDISCOVER_NETWORK_DETAILS = 'RECEIVE_REDISCOVER_NETWORK_DETAILS'
export const REQUEST_REDISCOVER_NETWORK_DETAILS_FAILURE = 'REQUEST_REDISCOVER_NETWORK_DETAILS_FAILURE'
export const INVALIDATE_REDISCOVER_NETWORK_DETAILS = 'INVALIDATE_REDISCOVER_NETWORK_DETAILS'

// -----------------------------------------------------------------------------
// Actions around an calendar

export const REQUEST_CALENDAR = 'REQUEST_CALENDAR'
export const RECEIVE_CALENDAR = 'RECEIVE_CALENDAR'
export const REQUEST_CALENDAR_FAILURE = 'REQUEST_CALENDAR_FAILURE'
export const INVALIDATE_CALENDAR = 'INVALIDATE_CALENDAR'

export const REQUEST_CALENDAR_EXPORT = 'REQUEST_CALENDAR_EXPORT'
export const RECEIVE_CALENDAR_EXPORT = 'RECEIVE_CALENDAR_EXPORT'
export const REQUEST_CALENDAR_EXPORT_FAILURE = 'REQUEST_CALENDAR_EXPORT_FAILURE'

// -----------------------------------------------------------------------------
// Actions around an Audience Acquisition

export const REQUEST_AUDIENCE_ACQUISITION = 'REQUEST_AUDIENCE_ACQUISITION'
export const RECEIVE_AUDIENCE_ACQUISITION = 'RECEIVE_AUDIENCE_ACQUISITION'
export const REQUEST_AUDIENCE_ACQUISITION_FAILURE = 'REQUEST_AUDIENCE_ACQUISITION_FAILURE'
export const INVALIDATE_AUDIENCE_ACQUISITION = 'INVALIDATE_AUDIENCE_ACQUISITION'

// -----------------------------------------------------------------------------
// Actions around Subscriber Overview

export const REQUEST_SUBSCRIBER_OVERVIEW = 'REQUEST_SUBSCRIBER_OVERVIEW'
export const RECEIVE_SUBSCRIBER_OVERVIEW = 'RECEIVE_SUBSCRIBER_OVERVIEW'
export const REQUEST_SUBSCRIBER_OVERVIEW_FAILURE = 'REQUEST_SUBSCRIBER_OVERVIEW_FAILURE'
export const INVALIDATE_SUBSCRIBER_OVERVIEW = 'INVALIDATE_SUBSCRIBER_OVERVIEW'

export const REQUEST_SUBSCRIBER_GENRE_TITLE = 'REQUEST_SUBSCRIBER_GENRE_TITLE'
export const RECEIVE_SUBSCRIBER_GENRE_TITLE = 'RECEIVE_SUBSCRIBER_GENRE_TITLE'
export const REQUEST_SUBSCRIBER_GENRE_TITLE_FAILURE = 'REQUEST_SUBSCRIBER_GENRE_TITLE_FAILURE'
export const INVALIDATE_SUBSCRIBER_GENRE_TITLE = 'INVALIDATE_SUBSCRIBER_GENRE_TITLE'

export const REQUEST_SUBSCRIBER_OVERVIEW_CALENDAR = 'REQUEST_SUBSCRIBER_OVERVIEW_CALENDAR'
export const RECEIVE_SUBSCRIBER_OVERVIEW_CALENDAR = 'RECEIVE_SUBSCRIBER_OVERVIEW_CALENDAR'
export const REQUEST_SUBSCRIBER_OVERVIEW_CALENDAR_FAILURE = 'REQUEST_SUBSCRIBER_OVERVIEW_CALENDAR_FAILURE'
export const INVALIDATE_SUBSCRIBER_OVERVIEW_CALENDAR = 'INVALIDATE_SUBSCRIBER_OVERVIEW_CALENDAR'

export const SUBSCRIBER_SELECTED_NETWORK = 'SUBSCRIBER_SELECTED_NETWORK'
export const SUBSCRIBER_SELECTED_NETWORK_TYPE = 'SUBSCRIBER_SELECTED_NETWORK_TYPE'
export const SUBSCRIBERS_SELECTED_QUARTER = 'SUBSCRIBERS_SELECTED_QUARTER'

// -----------------------------------------------------------------------------
// Actions around Burner Links

export const REQUEST_SHORTCUT = 'REQUEST_SHORTCUT'
export const RECEIVE_SHORTCUT = 'RECEIVE_SHORTCUT'
export const REQUEST_SHORTCUT_FAILURE = 'REQUEST_SHORTCUT_FAILURE'
export const INVALIDATE_SHORTCUT = 'INVALIDATE_SHORTCUT'

export const SHORTCUT_AUDIENCE_PREFERENCE = 'SHORTCUT_AUDIENCE_PREFERENCE'

export const SEARCH_RESULT_SUCCESS = 'SEARCH_RESULT_SUCCESS'
export const SEARCH_RESULT_CLEAR = 'SEARCH_RESULT_CLEAR'
export const SEARCH_RESULT_FAILURE = 'SEARCH_RESULT_FAILURE'
export const SEARCH_RESULT_REQUEST = 'SEARCH_RESULT_REQUEST'

export const REQUEST_FILTER = 'REQUEST_FILTER'
export const RECEIVE_FILTER = 'RECEIVE_FILTER'
export const REQUEST_FILTER_FAILURE = 'REQUEST_FILTER_FAILURE'
export const SUCCESS_FILTER = 'SUCCESS_FILTER'

// -----------------------------------------------------------------------------
// Actions around Attention Index

export const REQUEST_ATTENTION_INDEX = 'REQUEST_ATTENTION_INDEX'
export const RECEIVE_ATTENTION_INDEX = 'RECEIVE_ATTENTION_INDEX'
export const REQUEST_ATTENTION_INDEX_FAILURE = 'REQUEST_ATTENTION_INDEX_FAILURE'
export const INVALIDATE_ATTENTION_INDEX = 'INVALIDATE_ATTENTION_INDEX'

export const REQUEST_ATTENTION_TOP_TRENDING = 'REQUEST_ATTENTION_TOP_TRENDING'
export const RECEIVE_ATTENTION_TOP_TRENDING = 'RECEIVE_ATTENTION_TOP_TRENDING'
export const REQUEST_ATTENTION_TOP_TRENDING_FAILURE = 'REQUEST_ATTENTION_TOP_TRENDING_FAILURE'
export const INVALIDATE_ATTENTION_TOP_TRENDING = 'INVALIDATE_ATTENTION_TOP_TRENDING'

export const REQUEST_ATTENTION_ANTICIPATION = 'REQUEST_ATTENTION_ANTICIPATION'
export const RECEIVE_ATTENTION_ANTICIPATION = 'RECEIVE_ATTENTION_ANTICIPATION'
export const REQUEST_ATTENTION_ANTICIPATION_FAILURE = 'REQUEST_ATTENTION_ANTICIPATION_FAILURE'
export const INVALIDATE_ATTENTION_ANTICIPATION = 'INVALIDATE_ATTENTION_ANTICIPATION'

// -----------------------------------------------------------------------------
// Actions around Budgets and Subscribers

export const REQUEST_BUDGET_SUBSCRIBERS = 'REQUEST_BUDGET_SUBSCRIBERS'
export const RECEIVE_BUDGET_SUBSCRIBERS = 'RECEIVE_BUDGET_SUBSCRIBERS'
export const REQUEST_BUDGET_SUBSCRIBERS_FAILURE = 'REQUEST_BUDGET_SUBSCRIBERS_FAILURE'
export const INVALIDATE_BUDGET_SUBSCRIBERS = 'INVALIDATE_BUDGET_SUBSCRIBERS'

export const REQUEST_BUDGET_SUBSCRIBERS_QUARTERS = 'REQUEST_BUDGET_SUBSCRIBERS_QUARTERS'
export const RECEIVE_BUDGET_SUBSCRIBERS_QUARTERS = 'RECEIVE_BUDGET_SUBSCRIBERS_QUARTERS'
export const REQUEST_BUDGET_SUBSCRIBERS_QUARTERS_FAILURE = 'REQUEST_BUDGET_SUBSCRIBERS_QUARTERS_FAILURE'
export const INVALIDATE_BUDGET_SUBSCRIBERS_QUARTERS = 'INVALIDATE_BUDGET_SUBSCRIBERS_QUARTERS'

export const REQUEST_BUDGET_SUBSCRIBERS_EXPORT = 'REQUEST_BUDGET_SUBSCRIBERS_EXPORT'
export const RECEIVE_BUDGET_SUBSCRIBERS_EXPORT = 'RECEIVE_BUDGET_SUBSCRIBERS_EXPORT'
export const REQUEST_BUDGET_SUBSCRIBERS_EXPORT_FAILURE = 'REQUEST_BUDGET_SUBSCRIBERS_EXPORT_FAILURE'
export const INVALIDATE_BUDGET_SUBSCRIBERS_EXPORT = 'INVALIDATE_BUDGET_SUBSCRIBERS_EXPORT'

export const BUDGET_SUBSCRIBERS_SELECTED_QUARTER = 'BUDGET_SUBSCRIBERS_SELECTED_QUARTER'


// -----------------------------------------------------------------------------

// -----------------------------------------------------------------------------
// Actions around Budgets and Subscribers

export const REQUEST_SOV_NETWORKS = 'REQUEST_SOV_NETWORKS'
export const RECEIVE_SOV_NETWORKS = 'RECEIVE_SOV_NETWORKS'
export const REQUEST_SOV_NETWORKS_FAILURE = 'REQUEST_SOV_NETWORKS_FAILURE'
export const INVALIDATE_SOV_NETWORKS = 'INVALIDATE_SOV_NETWORKS'

export const REQUEST_SOV_CONTENT_RANK = 'REQUEST_SOV_CONTENT_RANK'
export const RECEIVE_SOV_CONTENT_RANK = 'RECEIVE_SOV_CONTENT_RANK'
export const REQUEST_SOV_CONTENT_RANK_FAILURE = 'REQUEST_SOV_CONTENT_RANK_FAILURE'
export const INVALIDATE_SOV_CONTENT_RANK = 'INVALIDATE_SOV_CONTENT_RANK'

export const REQUEST_SOV_CONTENT_RANK_SCORE = 'REQUEST_SOV_CONTENT_RANK_SCORE'
export const RECEIVE_SOV_CONTENT_RANK_SCORE = 'RECEIVE_SOV_CONTENT_RANK_SCORE'
export const REQUEST_SOV_CONTENT_RANK_SCORE_FAILURE = 'REQUEST_SOV_CONTENT_RANK_SCORE_FAILURE'
export const INVALIDATE_SOV_CONTENT_RANK_SCORE = 'INVALIDATE_SOV_CONTENT_RANK_SCORE'

export const SOV_SELECTED_CATEGORY = 'SOV_SELECTED_CATEGORY'

export const SOV_SELECTED_METRIC_DATE = 'SOV_SELECTED_METRIC_DATE'

// -----------------------------------------------------------------------------

export const SIDEBAR_SELECTED_NAV = 'SIDEBAR_SELECTED_NAV'

//---------------------------------------------------------------------------------
export const REQUEST_ANTICIPATION_INDEX = 'REQUEST_ANTICIPATION_INDEX'
export const RECEIVE_ANTICIPATION_INDEX = 'RECEIVE_ANTICIPATION_INDEX'
export const REQUEST_ANTICIPATION_INDEX_FAILURE = 'REQUEST_ANTICIPATION_INDEX_FAILURE'
export const INVALIDATE_ANTICIPATION_INDEX = 'INVALIDATE_ANTICIPATION_INDEX'

export const REQUEST_TOP_CONTENT_INDEX = 'REQUEST_TOP_CONTENT_INDEX'
export const RECEIVE_TOP_CONTENT_INDEX = 'RECEIVE_TOP_CONTENT_INDEX'
export const REQUEST_TOP_CONTENT_INDEX_FAILURE = 'REQUEST_TOP_CONTENT_INDEX_FAILURE'
export const INVALIDATE_TOP_CONTENT_INDEX = 'INVALIDATE_TOP_CONTENT_INDEX'

export const REQUEST_TRENDING_INDEX = 'REQUEST_TRENDING_INDEX'
export const RECEIVE_TRENDING_INDEX = 'RECEIVE_TRENDING_INDEX'
export const REQUEST_TRENDING_INDEX_FAILURE = 'REQUEST_TRENDING_INDEX_FAILURE'
export const INVALIDATE_TRENDING_INDEX = 'INVALIDATE_TRENDING_INDEX'

export const REQUEST_CANCELLED_SHOWS_INDEX = 'REQUEST_CANCELLED_SHOWS_INDEX'
export const RECEIVE_CANCELLED_SHOWS_INDEX = 'RECEIVE_CANCELLED_SHOWS_INDEX'
export const REQUEST_CANCELLED_SHOWS_INDEX_FAILURE = 'REQUEST_CANCELLED_SHOWS_INDEX_FAILURE'
export const INVALIDATE_CANCELLED_SHOWS_INDEX = 'INVALIDATE_CANCELLED_SHOWS_INDEX'

export const REQUEST_ANTICIPATION_INDEX_SCORE = 'REQUEST_ANTICIPATION_INDEX_SCORE'
export const RECEIVE_ANTICIPATION_INDEX_SCORE = 'RECEIVE_ANTICIPATION_INDEX_SCORE'
export const REQUEST_ANTICIPATION_INDEX_SCORE_FAILURE = 'REQUEST_ANTICIPATION_INDEX_SCORE_FAILURE'
export const INVALIDATE_ANTICIPATION_INDEX_SCORE = 'INVALIDATE_ANTICIPATION_INDEX_SCOR'

export const SELECTED_ATTENTION_INDEX_DATE = 'SELECTED_ATTENTION_INDEX_DATE'
export const SELECTED_ATTENTION_INDEX_VIEW = 'SELECTED_ATTENTION_INDEX_VIEW'

// -----------------------------------------------------------------------------
// Actions around an chat

export const REQUEST_THREAD = 'REQUEST_THREAD'
export const RECEIVE_THREAD = 'RECEIVE_THREAD'
export const REQUEST_THREAD_FAILURE = 'REQUEST_THREAD_FAILURE'
export const INVALIDATE_THREAD = 'INVALIDATE_THREAD'

export const REQUEST_CHAT = 'REQUEST_CHAT'
export const RECEIVE_CHAT = 'RECEIVE_CHAT'
export const REQUEST_CHAT_FAILURE = 'REQUEST_CHAT_FAILURE'
export const INVALIDATE_CHAT = 'INVALIDATE_CHAT'